import { createAsyncThunk } from "@reduxjs/toolkit";
import { send } from "../../app/appSlice";
import { AppThunkApi } from "../../app/store";
import { WarningRulesData } from "../../models/Anaylse";
import * as S from "../../services/WarningRulesAnaylse";

export const getWarningRuleAnaylseData = createAsyncThunk<
    WarningRulesData[],
    S.WarningRulesAnaylseParams,
    AppThunkApi
>("WarningRule/getAnaylseData", async (params, api) => {
    return send(S.getWarningRuleAnaylse(params), api);
});